import React, { useCallback, useEffect, useState } from 'react';
import {
  Input,
  Table,
  Space,
  notification,
} from "antd";
import { getAllUsers } from '../../../services/get-all-users';
import { NotificationType } from "../../../services/types";
import SubHeading from '../../../components/SubHeading/sub-heading';

export const search = (data: any, value: any, setFilteredData: any) => {
   const filtered = data.filter((item: any) =>
     Object.values(item).some((field) =>
       String(field).toLowerCase().includes(value.toLowerCase()),
     ),
   );
   setFilteredData(filtered);
 };

const { Search } = Input;

const UserList: React.FC = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState<boolean>(true);

  const openNotification = useCallback(
    (type: NotificationType, description: string) => {
      api[type]({
        message: "",
        description: `${description}`,
      });
    },
    [api],
  );

  const fetchData = useCallback(() => {
    getAllUsers().then((result) => {
      if (result) {
        const formattedUserList = result.responseData.users.map(
          (item: any, index: number) => {
            return {
              key: index,
              firstName: item?.firstName,
              lastName: item?.lastName,
              userType: item?.userType,
              organization: item?.organization,
              email: item?.email,
              phone: item?.phone,
              status: item?.status,
            };
          },
        );
        setTableData(formattedUserList);
        setFilteredData(formattedUserList);
        setLoading(false);
      } else {
        setLoading(false);
        openNotification("error", "failed to load user List");
      }
    });
  }, [openNotification]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearch = (value: any) => {
    search(tableData, value, setFilteredData);
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      editable: true,
      width: "12%",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      editable: true,
      width: "12%",
    },
    {
      title: "User Type",
      dataIndex: "userType",
      editable: true,
      width: "12%",
    },
    {
      title: "Organization",
      dataIndex: "organization",
      editable: true,
      width: "12%",
    },
    {
      title: "Email",
      dataIndex: "email",
      editable: true,
      width: "20%",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      editable: true,
      width: "10%",
    },
    {
      title: "Status",
      dataIndex: "status",
      editable: true,
      width: "10%",
    },
  ];

  return (
    <>
      <div className="dashboard-wrapper" id="dashboard-wrapper-title">
        <SubHeading
          title="Users"
        />
        <div className="dashboard-container">
          <Space direction="vertical">
            <Search placeholder="search" onSearch={handleSearch} allowClear style={{ width: 463 }} />
          </Space>
            <Table
              columns={columns}
              tableLayout="fixed"
              size="small"
              pagination={{ pageSize: 6, showSizeChanger: false }}
              dataSource={filteredData}
              loading={loading}
            />
        </div>
      </div>
      {contextHolder}
    </>
  );
};

export default UserList;
